export const StatusBadge = ({ status, testId }) => {
  const styles =
    status === "confirmed"
      ? "border-emerald-500/40 bg-emerald-950/40 text-emerald-300"
      : "border-zinc-700 bg-zinc-900 text-zinc-500";
  return (
    <span data-testid={testId} className={`inline-flex items-center rounded-full border px-3 py-1 font-tech text-[10px] uppercase tracking-[0.2em] ${styles}`}>
      {status}
    </span>
  );
};
